import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetOtherBranchCountResponse {
    pending_customer_count: number;
    total_pending_amount: number;
    monthly_order_amount: number;
    monthly_order_count: number;
    monthly_payment_amount: number;
}

export const useGetOtherBranchCount = (): UseQueryResult<GetOtherBranchCountResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetOtherBranchCountResponse, Error>({
        queryKey: ["getOtherBranchCount"],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_settlements_count}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
    });
};
